module.exports = __webpack_public_path__ + "static/media/female2.b82f7ddb.jpg";